module.exports = __webpack_public_path__ + "img/deer.f83638b4.svg";